import React from 'react'
import ClientLogo from 'components/shared/ClientLogo'
import delve from 'dlv'
import classnames from 'classnames/bind'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const LogosList = ({ className, brands }) => {
  return (
    <div className={cx(className, css.LogosList)}>
      {brands.map((brand, id) => {
        const logo = delve(brand, 'logo')
        const greyLogo = delve(brand, 'greyLogo')
        const link = delve(brand, 'link')

        return (
          <ClientLogo key={id} logo={logo} greyLogo={greyLogo} link={link} />
        )
      })}
    </div>
  )
}

LogosList.defaultProps = {}

export default LogosList
